export default "__VITE_ASSET__DWm7JxoM__"